import { useState } from "react";
import {
  Combobox,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  ComboboxButton,
} from "@headlessui/react";

import { useTable } from "storev2/tableStore";
import { cn } from "tools/ui";
import { theme } from "theme/theme";
import { useIntl, FormattedMessage as FM } from "react-intl";
import { ChevronDownIcon, TrashIcon } from "components/Icons";

function SelectionFilter(props) {
  const { getDomain, setDomain, reload } = useTable();
  const {
    name,
    options: initialOptions = [],
    data,
    placeholder,
    onChange,
    layout,
    storeId,
  } = props;

  const intl = useIntl();
  const [options, setOptions] = useState(initialOptions);
  const [filtered, setFiltered] = useState(initialOptions);
  const [selected, setSelected] = useState(
    typeof data === "object" && data?.id ? data : null,
  );

  function handleInput(e) {
    const q = e.target.value.toLowerCase();
    if (!q) return setFiltered(initialOptions);
    setFiltered(
      initialOptions.filter((opt) => opt.name.toLowerCase().includes(q)),
    );
  }

  function handleChange(value) {
    setSelected(value);
    onChange?.(name, value);
  }

  function handleClearField(name) {
    const currentDomain = getDomain("filter", storeId, []) || [];

    const newDomain = currentDomain.map((group) => {
      if (Array.isArray(group[0]) && Array.isArray(group[0][0])) {
        return group;
      } else {
        return group.filter((condition) => condition[0] !== name);
      }
    });

    setSelected(null);
    setOptions(initialOptions);
    setFiltered(initialOptions);

    reload(storeId, { filter: newDomain });
  }

  return (
    <div className="relative min-w-[180px]">
      <Combobox value={selected} onChange={handleChange}>
        <ComboboxInput
          className={cn(
            "w-full shadow-sm border border-gray-200 rounded-xl py-2 px-3 bg-white outline-none pr-8",
            theme.textColor,
          )}
          placeholder={
            placeholder
              ? intl.formatMessage({ id: placeholder })
              : "Seleccionar..."
          }
          displayValue={(v) => v?.name || ""}
          onChange={handleInput}
        />

        {filtered.length > 0 && (
          <ComboboxOptions className="text-xs absolute z-50 mt-1 w-full bg-white rounded-md max-h-60 overflow-auto shadow-sm border border-gray-200">
            {filtered.map((option) => (
              <ComboboxOption
                key={option.id}
                value={option}
                className={({ active }) =>
                  cn(
                    "p-2 cursor-pointer truncate uppercase",
                    active ? "bg-blue-100" : "bg-white",
                  )
                }
              >
                <FM id={option.name} />
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        )}

        <ComboboxButton
          as="div"
          className="absolute right-2 top-3 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            if (selected) handleClearField(name);
          }}
        >
          {selected ? (
            <TrashIcon className="fill-current text-rose-400 size-5" />
          ) : (
            <ChevronDownIcon className="fill-current text-gray-500 size-5" />
          )}
        </ComboboxButton>
      </Combobox>
    </div>
  );
}

export default SelectionFilter;
